const HeartInsuranceIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M15.74 0C13.88 0 12.17 0.77 11 2.07C9.83 0.77 8.12 0 6.26 0C2.81 0 0 2.69 0 6C0 14.47 10.06 20.6 10.49 20.86C10.64 20.95 10.82 21 11 21C11.09 21 11.17 20.99 11.26 20.96C10.5 19.7 10 18.23 10 16.55V12.54C10 11.36 10.75 10.31 11.87 9.93L17.11 8.15C17.68 7.95 18.32 7.95 18.89 8.15L21.57 9.06C21.84 8.08 22 7.06 22 6C22 2.69 19.19 0 15.74 0Z"
        fill="black"
      />
      <path
        d="M23.491 11.826L18.241 10.04C18.085 9.98601 17.915 9.98601 17.759 10.04L12.509 11.826C12.204 11.929 12 12.214 12 12.536V16.554C12 21.458 17.474 23.842 17.707 23.941C17.895 24.02 18.105 24.02 18.293 23.941C18.526 23.841 24 21.458 24 16.554V12.536C24 12.214 23.796 11.929 23.491 11.826ZM21.286 15.618L18.536 19.118C18.186 19.565 17.53 19.63 17.099 19.26L15.349 17.76C14.929 17.401 14.88 16.769 15.241 16.35C15.6 15.931 16.232 15.883 16.65 16.242L17.608 17.063L19.713 14.384C20.054 13.95 20.682 13.873 21.117 14.216C21.552 14.555 21.628 15.184 21.286 15.618Z"
        fill="black"
      />
    </svg>
  );
};

export default HeartInsuranceIcon;
